import { loadModuleDirectly } from '../../../@Util/DependencyInjection/Injection/DependencyInjection';
import { WelcomeStore } from '../../../@Service/Welcome/WelcomeStore';

export default function isInPortal()
{
    return loadModuleDirectly(WelcomeStore).welcomePackage.user.portal !== undefined;
}
